import * as React from 'react'
const DashNotifsSVG = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
     width={props.width}
    height={props.height}
    viewBox="0 0 32 32"  // <-- اضافه کن
    {...props}
  >
    <path
      d='m26.363 19.32-1.335-2.213c-.28-.494-.534-1.427-.534-1.974V11.76c0-4.347-3.538-7.893-7.904-7.893-4.367 0-7.905 3.546-7.905 7.893v3.373c0 .547-.254 1.48-.534 1.96L6.802 19.32c-.534.893-.654 1.88-.32 2.787.32.893 1.082 1.586 2.07 1.92 2.59.88 5.314 1.306 8.038 1.306a25.36 25.36 0 0 0 8.038-1.293 3.2 3.2 0 0 0 2.003-1.933 3.165 3.165 0 0 0-.268-2.787Z'
      opacity={0.4}
    />
    <path
      d='M19.567 4.427a8.154 8.154 0 0 0-2.977-.56 7.866 7.866 0 0 0-2.964.56 3.343 3.343 0 0 1 2.964-1.76c1.268 0 2.39.68 2.977 1.76ZM20.342 26.68a4.025 4.025 0 0 1-3.779 2.653 3.962 3.962 0 0 1-2.83-1.186 3.68 3.68 0 0 1-.935-1.48c.173.026.347.04.534.066.307.04.627.08.948.107.761.067 1.535.107 2.31.107.76 0 1.522-.04 2.27-.107.28-.027.56-.04.828-.08l.654-.08Z'
    />
  </svg>
)
export default DashNotifsSVG
